import React, { useEffect, useState } from "react";
import "./PricingPlans.css";
import { getSubscriptionPlans } from "../services/pricingService";
import { useNavigate } from "react-router-dom";
import Loader from "./Loader";
import { useTranslation } from "react-i18next";

const PricingPlans = () => {
  const {t} = useTranslation();
  const [plans, setPlans] = useState([]);
  const [loadingPlanId, setLoadingPlanId] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    getSubscriptionPlans()
      .then((plans) => setPlans(plans))
      .catch((err) => {
        console.error("Error fetching subscription plans:", err);
        setError("Failed to load plans. Please refresh.");
      })
      .finally(() => setLoading(false));
  }, []);

  // ✅ Redirect to GPay page instead of Cashfree
  const handleGetPlan = (plan) => {
    navigate("/gpaypage", {
      state: {
        planName: plan.name,
        planPrice: plan.price,
      },
    });
  };

  return (
    <div className="pricing-container">
    { loading ? <Loader /> : '' }
      <h4 className="pricing-title">{t("pricing_plans")}</h4>
      <h1 className="pricing-heading">{t("find_your_perfect_match")}</h1>
      <p className="pricing-subheading">{t("choose_plan")}</p>

      {error && (
        <p
          style={{
            color: "#ff6b6b",
            textAlign: "center",
            marginBottom: "16px",
          }}
        >
          {error}
        </p>
      )}

      <div className="pricing-cards">
        {plans.length === 0 ? (
          <p style={{ color: "white" }}>No plans available</p>
        ) : (
          plans.map((plan) => (
            <div
              key={plan._id}
              className={`card ${plan.name === "Premium" ? "popular" : ""}`}
            >
              {plan.name === "Premium" && (
                <div className="badge">Most popular</div>
              )}

              <h3 className="plan-name">{plan.name || "No Name"}</h3>

              <h2 className="price">
                ₹{plan.price || 0}
                <span>/mo</span>
              </h2>

              <p className="desc">{plan.description || "No description"}</p>

              <hr />

              <ul>
                {Array.isArray(plan.features) && plan.features.length > 0 ? (
                  plan.features.map((feature, i) => (
                    <li key={feature._id || i}>
                      ✔ {feature?.name || "Feature"}
                      {feature?.limit ? ` (${feature.limit})` : ""}
                    </li>
                  ))
                ) : (
                  <li>No features available</li>
                )}
              </ul>

              {/* ✅ Redirect button */}
              <button className="btn" onClick={() => handleGetPlan(plan)}>
                {`Get ${plan.name || "Plan"}`}
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default PricingPlans;
